import { useState } from 'react';

export const TrainingState = () => {
    const [rLoader, setRLoader] = useState(false);
    const [nLoader, setNLoader] = useState(false);

    //currentSlide for kneel slider
    const [currentSlideNew, setCurrentSlideNew] = useState(0);
    const [currentSlideRecom, setCurrentSlideRecom] = useState(0);
    
    //MainContent Loader
    const [successOpen, setSuccessOpen] = useState(false);
    const [successSaving, setsuccessSaving] = useState(false);
    
    // REVISED STATES
    const [list, setList] = useState({filter: {toggled: false, profession: 0}, cpd: null, sdl: null, upcoming: null, webinar: null})
    const [search, setSearch] = useState({filter: {toggled: false, profession: 0}, input: {value: '', stat: false, msg: ''}, list: 1})
    const [tnew, setTnew] = useState(null)
    const [recommended, setRecommended] = useState(null)
    const [all, setAll] = useState([])
    const [preview, setPreview] = useState({})
    const [summaryCount, setSummaryCount] = useState({all:0, completed:0, enrolled: 0, ongoing: 0})
    const [tl, setTL] = useState({filter: {toggled: false, status: 'all'}, all: null, training: null, courses: null, technical: null, core: null})
    const [exclusive, setExclusive] = useState({code: null, step: 1, list: null, active: 'all',
        form: {
            toggled: false,
            loader: false,
            inputs: {value: '', stat: false, msg: ''},
        },
        filter: {toggled: false, status: 'all'}
    })
    
    // Trainings
    const [newType, setNewType] = useState(1)
    const [recommendedType, setRecommendedType] = useState(1)
    const [acad, setAcad] = useState({tnew: null, recommended: null})
    const [seeAll, setSeeAll] = useState({tnew: false, recommended: false});
    const [tredirection, setTredirection] = useState({stat: false, training: null})
    const [info, setInfo] = useState({list:null, detailed: false, preview: null, remove: null, premove: false, restore: false})
    const [typeTC, setTypeTC] = useState("training")
    
	return {
        sc: {data: summaryCount, set: setSummaryCount},
        csn: {data: currentSlideNew, set: setCurrentSlideNew},
        csr: {data: currentSlideRecom, set: setCurrentSlideRecom},
        tnew: {data:tnew, set:setTnew},
        recommended: {data:recommended, set:setRecommended},
		recomloader: {data:rLoader, set:setRLoader},
		newloader: {data:nLoader, set:setNLoader},
        successOpen: {data: successOpen, set: setSuccessOpen},
        successSaving: {data: successSaving, set: setsuccessSaving},
        newType: {data: newType, set: setNewType},
        recommendedType: {data: recommendedType, set: setRecommendedType},
        acad: {data: acad, set: setAcad},
        seeAll: {data: seeAll, set: setSeeAll},
        all: {data: all, set: setAll},
        list: {data: list, set: setList},
        search: {data: search, set: setSearch},
        preview: {data: preview, set: setPreview},
        tredirection: {data: tredirection, set: setTredirection},
        exclusive: {data: exclusive, set: setExclusive},
        info: {data: info, set: setInfo},
        tl: {data: tl, set: setTL},
        typeTC: {data: typeTC, set: setTypeTC},
	}
}